// extracted by mini-css-extract-plugin
export default {"logo_box":"index_logo_box_eNMMc","logoBox2":"index_logoBox2_-D8-X","logo_title":"index_logo_title_1q-HI","logo_finace":"index_logo_finace_DHz6d"};